import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { BankAccountsStatus } from 'enums/BankAccountsStatus';
import { BorrowerRole } from 'enums/BorrowerRole';
import { IncomeType } from 'enums/IncomeType';
import { SocialSecurityBenefitType } from 'enums/SocialSecurityBenefitType';

export interface BankAccount {
  bankName: string;
  routingNumber: string;
  accountType: string;
  accountNumber: string;
  bankId?: string;
}

export interface VerificationState {
  id: string;
  companyName: string;
  incomeType: IncomeType;
  verificationAttemptComplete: boolean;
  verificationRequired: boolean;
}

export interface CreateBridgeTokenDto {
  applicationId: string;
  borrowerId: string;
  borrowerType: BorrowerRole;
  socialSecurityBenefitType: SocialSecurityBenefitType | null;
  incomeSourceVerificationId?: string;
  useFinancialAccountAggregation?: boolean;
}

export interface CompleteVerificationDto {
  applicationId: string;
  borrowerType: BorrowerRole;
  verificationId: string;
  taskId: string;
}

export interface CompleteFinancialAccountAggregationDto {
  applicationId: string;
}

export interface SaveVerificationErrorDto {
  applicationId: string;
}

export interface GetBankAccountsDto {
  applicationId: string;
}

export interface SaveBankAccountInfoDto {
  bankId: string;
  applicationId: string;
}

export interface SetBankAccountStatusDto {
  applicationId: string;
  status: BankAccountsStatus;
}

export interface GetBridgeTokenResponseDto {
  token: string;
}

export interface GetBankAccountsResponseDto {
  status: BankAccountsStatus;
  chosenAccount: BankAccount;
  availableAccounts: BankAccount[];
}

export interface GetBankAccountsRefreshStatusResponseDto {
  status: BankAccountsStatus;
}

export default class TruvApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/truv' || '');
  }

  public async createBridgeToken(body: CreateBridgeTokenDto) {
    return this.instance
      .post('/createBridgeToken', body)
      .then((response: AxiosResponse<GetBridgeTokenResponseDto>) => response.data);
  }

  public async completeVerification(body: CompleteVerificationDto) {
    return this.instance.post('/completeVerification', body).then((response: AxiosResponse<void>) => response.data);
  }

  public async completeFinancialAccountAggregation(body: CompleteFinancialAccountAggregationDto) {
    return this.instance
      .put('/completeFinancialAccountAggregation', body)
      .then((response: AxiosResponse<void>) => response.data);
  }

  public async saveVerificationError(body: SaveVerificationErrorDto) {
    return this.instance.put('/verification-error', body).then((response: AxiosResponse<void>) => response.data);
  }

  public async getBankAccounts(body: GetBankAccountsDto) {
    return this.instance
      .post('/getBankAccounts', body)
      .then((response: AxiosResponse<GetBankAccountsResponseDto>) => response.data);
  }

  public async getBankAccountsRefreshStatus(body: GetBankAccountsDto) {
    return this.instance
      .post('/getBankAccountsRefreshStatus', body)
      .then((response: AxiosResponse<GetBankAccountsRefreshStatusResponseDto>) => response.data);
  }

  public async saveBankAccountInfo(body: SaveBankAccountInfoDto) {
    return this.instance.post('/saveBankAccountInfo', body).then((response: AxiosResponse<void>) => response.data);
  }

  public async setBankAccountStatus(body: SetBankAccountStatusDto) {
    return this.instance.post('/setBankAccountStatus', body).then((response: AxiosResponse<void>) => response.data);
  }
}

export const truvApi = new TruvApi();
